import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSearchDeceasedsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSearchDeceasedsController.php
* @route '/api/company/{company}/elys/search-deceaseds'
*/
const ElysSearchDeceasedsController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysSearchDeceasedsController.url(args, options),
    method: 'post',
})

ElysSearchDeceasedsController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/elys/search-deceaseds',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSearchDeceasedsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSearchDeceasedsController.php
* @route '/api/company/{company}/elys/search-deceaseds'
*/
ElysSearchDeceasedsController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysSearchDeceasedsController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSearchDeceasedsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSearchDeceasedsController.php
* @route '/api/company/{company}/elys/search-deceaseds'
*/
ElysSearchDeceasedsController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysSearchDeceasedsController.url(args, options),
    method: 'post',
})

export default ElysSearchDeceasedsController